import { ActionAdd } from './IconSVGs/ActionAdd';
import { ActionAddColumn } from './IconSVGs/ActionAddColumn';
import { ActionAttach } from './IconSVGs/ActionAttach';
import { ActionBlocked } from './IconSVGs/ActionBlocked';
import { ActionClose } from './IconSVGs/ActionClose';
import { ActionCloseSmall } from './IconSVGs/ActionCloseSmall';
import { ActionCloseThin } from './IconSVGs/ActionCloseThin';
import { ActionComment } from './IconSVGs/ActionComment';
import { ActionDelete } from './IconSVGs/ActionDelete';
import { ActionDownload } from './IconSVGs/ActionDownload';
import { ActionDuplicate } from './IconSVGs/ActionDuplicate';
import { ActionEdit } from './IconSVGs/ActionEdit';
import { ActionEmail } from './IconSVGs/ActionEmail';
import { ActionEnter } from './IconSVGs/ActionEnter';
import { ActionExport } from './IconSVGs/ActionExport';
import { ActionFavorite } from './IconSVGs/ActionFavorite';
import { ActionGrab } from './IconSVGs/ActionGrab';
import { ActionHide } from './IconSVGs/ActionHide';
import { ActionInstall } from './IconSVGs/ActionInstall';
import { ActionLess } from './IconSVGs/ActionLess';
import { ActionLocate } from './IconSVGs/ActionLocate';
import { ActionMore } from './IconSVGs/ActionMore';
import { ActionMove } from './IconSVGs/ActionMove';
import { ActionPin } from './IconSVGs/ActionPin';
import { ActionPrint } from './IconSVGs/ActionPrint';
import { ActionRefresh } from './IconSVGs/ActionRefresh';
import { ActionRemoveFavoriteStarIcon } from './IconSVGs/ActionRemoveFavoriteStarIcon';
import { ActionRenew } from './IconSVGs/ActionRenew';
import { ActionReset } from './IconSVGs/ActionReset';
import { ActionSave } from './IconSVGs/ActionSave';
import { ActionSchedule } from './IconSVGs/ActionSchedule';
import { ActionSearch } from './IconSVGs/ActionSearch';
import { ActionShare } from './IconSVGs/ActionShare';
import { ActionShow } from './IconSVGs/ActionShow';
import { ActionSort } from './IconSVGs/ActionSort';
import { ActionStarFavorite } from './IconSVGs/ActionStarFavorite';
import { ActionUndo } from './IconSVGs/ActionUndo';
import { ActionUpload } from './IconSVGs/ActionUpload';
import { ArrowCaretDown } from './IconSVGs/ArrowCaretDown';
import { ArrowCaretDownSmall } from './IconSVGs/ArrowCaretDownSmall';
import { ArrowCaretLeft } from './IconSVGs/ArrowCaretLeft';
import { ArrowCaretLeftSmall } from './IconSVGs/ArrowCaretLeftSmall';
import { ArrowCaretRight } from './IconSVGs/ArrowCaretRight';
import { ArrowCaretRightSmall } from './IconSVGs/ArrowCaretRightSmall';
import { ArrowCaretUp } from './IconSVGs/ArrowCaretUp';
import { ArrowCaretUpSmall } from './IconSVGs/ArrowCaretUpSmall';
import { ArrowChevronDown } from './IconSVGs/ArrowChevronDown';
import { ArrowChevronDownSmall } from './IconSVGs/ArrowChevronDownSmall';
import { ArrowChevronLeft } from './IconSVGs/ArrowChevronLeft';
import { ArrowChevronLeftSmall } from './IconSVGs/ArrowChevronLeftSmall';
import { ArrowChevronRight } from './IconSVGs/ArrowChevronRight';
import { ArrowChevronRightSmall } from './IconSVGs/ArrowChevronRightSmall';
import { ArrowChevronUp } from './IconSVGs/ArrowChevronUp';
import { ArrowChevronUpSmall } from './IconSVGs/ArrowChevronUpSmall';
import { ArrowDown } from './IconSVGs/ArrowDown';
import { ArrowDownSmall } from './IconSVGs/ArrowDownSmall';
import { ArrowLeft } from './IconSVGs/ArrowLeft';
import { ArrowLeftSmall } from './IconSVGs/ArrowLeftSmall';
import { ArrowRight } from './IconSVGs/ArrowRight';
import { ArrowRightSmall } from './IconSVGs/ArrowRightSmall';
import { ArrowUp } from './IconSVGs/ArrowUp';
import { ArrowUpSmall } from './IconSVGs/ArrowUpSmall';
import { ChartArea } from './IconSVGs/ChartArea';
import { ChartBar } from './IconSVGs/ChartBar';
import { ChartBullet } from './IconSVGs/ChartBullet';
import { ChartBulletOutline } from './IconSVGs/ChartBulletOutline';
import { ChartDoubleBar } from './IconSVGs/ChartDoubleBar';
import { ChartGauge } from './IconSVGs/ChartGauge';
import { ChartGaugeOutline } from './IconSVGs/ChartGaugeOutline';
import { ChartGroupedBar } from './IconSVGs/ChartGroupedBar';
import { ChartHorizontalBar } from './IconSVGs/ChartHorizontalBar';
import { ChartLine } from './IconSVGs/ChartLine';
import { ChartMap } from './IconSVGs/ChartMap';
import { ChartPercentArea } from './IconSVGs/ChartPercentArea';
import { ChartPercentBar } from './IconSVGs/ChartPercentBar';
import { ChartPercentBarOutline } from './IconSVGs/ChartPercentBarOutline';
import { ChartPie } from './IconSVGs/ChartPie';
import { DatatypeCurrency } from './IconSVGs/DatatypeCurrency';
import { DatatypeDate } from './IconSVGs/DatatypeDate';
import { DatatypeEmail } from './IconSVGs/DatatypeEmail';
import { DatatypeHome } from './IconSVGs/DatatypeHome';
import { DatatypeLocation } from './IconSVGs/DatatypeLocation';
import { DatatypeNumeric } from './IconSVGs/DatatypeNumeric';
import { DatatypePercentage } from './IconSVGs/DatatypePercentage';
import { DatatypePhone } from './IconSVGs/DatatypePhone';
import { DatatypeText } from './IconSVGs/DatatypeText';
import { EditorAlignCenter } from './IconSVGs/EditorAlignCenter';
import { EditorAlignLeft } from './IconSVGs/EditorAlignLeft';
import { EditorAlignRight } from './IconSVGs/EditorAlignRight';
import { EditorBackgroundColor } from './IconSVGs/EditorBackgroundColor';
import { EditorBackgroundImage } from './IconSVGs/EditorBackgroundImage';
import { EditorBlockquote } from './IconSVGs/EditorBlockquote';
import { EditorBold } from './IconSVGs/EditorBold';
import { EditorCrop } from './IconSVGs/EditorCrop';
import { EditorDelete } from './IconSVGs/EditorDelete';
import { EditorItalics } from './IconSVGs/EditorItalics';
import { EditorLayout } from './IconSVGs/EditorLayout';
import { EditorLink } from './IconSVGs/EditorLink';
import { EditorOrderedList } from './IconSVGs/EditorOrderedList';
import { EditorRemoveLink } from './IconSVGs/EditorRemoveLink';
import { EditorTextColor } from './IconSVGs/EditorTextColor';
import { EditorUnderline } from './IconSVGs/EditorUnderline';
import { EditorUnorderedList } from './IconSVGs/EditorUnorderedList';
import { FormCheck } from './IconSVGs/FormCheck';
import { LayoutGrid } from './IconSVGs/LayoutGrid';
import { LayoutList } from './IconSVGs/LayoutList';
import { LayoutMap } from './IconSVGs/LayoutMap';
import { LayoutTable } from './IconSVGs/LayoutTable';
import { LogoFacebook } from './IconSVGs/LogoFacebook';
import { LogoInstagram } from './IconSVGs/LogoInstagram';
import { LogoLinkedin } from './IconSVGs/LogoLinkedin';
import { LogoOpengov } from './IconSVGs/LogoOpengov';
import { LogoOpengovWand } from './IconSVGs/LogoOpengovWand';
import { LogoTwitter } from './IconSVGs/LogoTwitter';
import { LogoYoutube } from './IconSVGs/LogoYoutube';
import { ObjectCompleteInspection } from './IconSVGs/ObjectCompleteInspection';
import { ObjectDocument } from './IconSVGs/ObjectDocument';
import { ObjectEmbed } from './IconSVGs/ObjectEmbed';
import { ObjectEmployees } from './IconSVGs/ObjectEmployees';
import { ObjectExternalLink } from './IconSVGs/ObjectExternalLink';
import { ObjectFolder } from './IconSVGs/ObjectFolder';
import { ObjectGroup } from './IconSVGs/ObjectGroup';
import { ObjectImage } from './IconSVGs/ObjectImage';
import { ObjectInspection } from './IconSVGs/ObjectInspection';
import { ObjectMap } from './IconSVGs/ObjectMap';
import { ObjectNotFound } from './IconSVGs/ObjectNotFound';
import { ObjectPayment } from './IconSVGs/ObjectPayment';
import { ObjectTag } from './IconSVGs/ObjectTag';
import { ObjectTags } from './IconSVGs/ObjectTags';
import { ObjectUser } from './IconSVGs/ObjectUser';
import { ObjectVideo } from './IconSVGs/ObjectVideo';
import { ObjectView } from './IconSVGs/ObjectView';
import { ObjectWorld } from './IconSVGs/ObjectWorld';
import { OpenGovLogo } from './IconSVGs/OpenGovBrandedLogo';
import { OpenGovLogoWand } from './IconSVGs/OpenGovBrandedLogoWand';
import { OperatorAdd } from './IconSVGs/OperatorAdd';
import { OperatorContains } from './IconSVGs/OperatorContains';
import { OperatorDivide } from './IconSVGs/OperatorDivide';
import { OperatorDoesNotContain } from './IconSVGs/OperatorDoesNotContain';
import { OperatorEqual } from './IconSVGs/OperatorEqual';
import { OperatorGreaterThan } from './IconSVGs/OperatorGreaterThan';
import { OperatorGreaterThanOrEqual } from './IconSVGs/OperatorGreaterThanOrEqual';
import { OperatorIsFilled } from './IconSVGs/OperatorIsFilled';
import { OperatorIsNotFilled } from './IconSVGs/OperatorIsNotFilled';
import { OperatorLessThan } from './IconSVGs/OperatorLessThan';
import { OperatorLessThanOrEqual } from './IconSVGs/OperatorLessThanOrEqual';
import { OperatorMultiply } from './IconSVGs/OperatorMultiply';
import { OperatorNotEqual } from './IconSVGs/OperatorNotEqual';
import { OperatorSubtract } from './IconSVGs/OperatorSubtract';
import { ProductBnP } from './IconSVGs/ProductBnP';
import { ProductCIT } from './IconSVGs/ProductCIT';
import { ProductEAM } from './IconSVGs/ProductEAM';
import { ProductFin } from './IconSVGs/ProductFin';
import { ProductOD } from './IconSVGs/ProductOD';
import { ProductOTH } from './IconSVGs/ProductOTH';
import { ProductPro } from './IconSVGs/ProductPRO';
import { ProductRnT } from './IconSVGs/ProductRnT';
import { StatusBlocked } from './IconSVGs/StatusBlocked';
import { StatusError } from './IconSVGs/StatusError';
import { StatusInfo } from './IconSVGs/StatusInfo';
import { StatusLocked } from './IconSVGs/StatusLocked';
import { StatusShared } from './IconSVGs/StatusShared';
import { StatusSuccess } from './IconSVGs/StatusSuccess';
import { StatusUnlocked } from './IconSVGs/StatusUnlocked';
import { StatusWarning } from './IconSVGs/StatusWarning';
import { TransactionCreditCard } from './IconSVGs/TransactionCreditCard';
import { UtilityAdmin } from './IconSVGs/UtilityAdmin';
import { UtilityBatch } from './IconSVGs/UtilityBatch';
import { UtilityCalculator } from './IconSVGs/UtilityCalculator';
import { UtilityComments } from './IconSVGs/UtilityComments';
import { UtilityDirectories } from './IconSVGs/UtilityDirectories';
import { UtilityDocumentation } from './IconSVGs/UtilityDocumentation';
import { UtilityExcel } from './IconSVGs/UtilityExcel';
import { UtilityFilter } from './IconSVGs/UtilityFilter';
import { UtilityHelp } from './IconSVGs/UtilityHelp';
import { UtilityHelpOutline } from './IconSVGs/UtilityHelpOutline';
import { UtilityInfo } from './IconSVGs/UtilityInfo';
import { UtilityInfoOutline } from './IconSVGs/UtilityInfoOutline';
import { UtilityMenu } from './IconSVGs/UtilityMenu';
import { UtilityNotes } from './IconSVGs/UtilityNotes';
import { UtilityNotifications } from './IconSVGs/UtilityNotifications';
import { UtilityOverflow } from './IconSVGs/UtilityOverflow';
import { UtilityOverflowHorizontal } from './IconSVGs/UtilityOverflowHorizontal';
import { UtilitySettings } from './IconSVGs/UtilitySettings';
import { UtilitySpooler } from './IconSVGs/UtilitySpooler';

export const IconSVGs = {
  'action-add': ActionAdd,
  'action-add-column': ActionAddColumn,
  'action-attach': ActionAttach,
  'action-blocked': ActionBlocked,
  'action-close-small': ActionCloseSmall,
  'action-close-thin': ActionCloseThin,
  'action-close': ActionClose,
  'action-comment': ActionComment,
  'action-delete': ActionDelete,
  'action-download': ActionDownload,
  'action-duplicate': ActionDuplicate,
  'action-edit': ActionEdit,
  'action-email': ActionEmail,
  'action-enter': ActionEnter,
  'action-export': ActionExport,
  'action-favorite': ActionFavorite,
  'action-grab': ActionGrab,
  'action-hide': ActionHide,
  'action-install': ActionInstall,
  'action-less': ActionLess,
  'action-locate': ActionLocate,
  'action-more': ActionMore,
  'action-move': ActionMove,
  'action-pin': ActionPin,
  'action-print': ActionPrint,
  'action-refresh': ActionRefresh,
  'action-remove-favorite-star': ActionRemoveFavoriteStarIcon,
  'action-renew': ActionRenew,
  'action-reset': ActionReset,
  'action-save': ActionSave,
  'action-schedule': ActionSchedule,
  'action-search': ActionSearch,
  'action-share': ActionShare,
  'action-show': ActionShow,
  'action-sort': ActionSort,
  'action-undo': ActionUndo,
  'action-upload': ActionUpload,
  'arrow-caret-down': ArrowCaretDown,
  'arrow-caret-down-small': ArrowCaretDownSmall,
  'arrow-caret-left': ArrowCaretLeft,
  'arrow-caret-left-small': ArrowCaretLeftSmall,
  'arrow-caret-right': ArrowCaretRight,
  'arrow-caret-right-small': ArrowCaretRightSmall,
  'arrow-caret-up': ArrowCaretUp,
  'arrow-caret-up-small': ArrowCaretUpSmall,
  'arrow-chevron-down': ArrowChevronDown,
  'arrow-chevron-down-small': ArrowChevronDownSmall,
  'arrow-chevron-left': ArrowChevronLeft,
  'arrow-chevron-left-small': ArrowChevronLeftSmall,
  'arrow-chevron-right': ArrowChevronRight,
  'arrow-chevron-right-small': ArrowChevronRightSmall,
  'arrow-chevron-up': ArrowChevronUp,
  'arrow-chevron-up-small': ArrowChevronUpSmall,
  'arrow-down-small': ArrowDownSmall,
  'arrow-down': ArrowDown,
  'arrow-left-small': ArrowLeftSmall,
  'arrow-left': ArrowLeft,
  'arrow-right-small': ArrowRightSmall,
  'arrow-right': ArrowRight,
  'action-star-favorite': ActionStarFavorite,
  'arrow-up-small': ArrowUpSmall,
  'arrow-up': ArrowUp,
  'chart-area': ChartArea,
  'chart-bar': ChartBar,
  'chart-bullet': ChartBullet,
  'chart-bullet-outline': ChartBulletOutline,
  'chart-doublebar': ChartDoubleBar,
  'chart-gauge': ChartGauge,
  'chart-gauge-outline': ChartGaugeOutline,
  'chart-groupedbar': ChartGroupedBar,
  'chart-horizontalbar': ChartHorizontalBar,
  'chart-line': ChartLine,
  'chart-map': ChartMap,
  'chart-percentarea': ChartPercentArea,
  'chart-percentbar': ChartPercentBar,
  'chart-percentbar-outline': ChartPercentBarOutline,
  'chart-pie': ChartPie,
  'datatype-currency': DatatypeCurrency,
  'datatype-date': DatatypeDate,
  'datatype-email': DatatypeEmail,
  'datatype-home': DatatypeHome,
  'datatype-location': DatatypeLocation,
  'datatype-numeric': DatatypeNumeric,
  'datatype-percentage': DatatypePercentage,
  'datatype-phone': DatatypePhone,
  'datatype-text': DatatypeText,
  'editor-align-center': EditorAlignCenter,
  'editor-align-left': EditorAlignLeft,
  'editor-align-right': EditorAlignRight,
  'editor-backgroundcolor': EditorBackgroundColor,
  'editor-backgroundimage': EditorBackgroundImage,
  'editor-blockquote': EditorBlockquote,
  'editor-bold': EditorBold,
  'editor-crop': EditorCrop,
  'editor-delete': EditorDelete,
  'editor-italics': EditorItalics,
  'editor-layout': EditorLayout,
  'editor-link': EditorLink,
  'editor-orderedlist': EditorOrderedList,
  'editor-removelink': EditorRemoveLink,
  'editor-textcolor': EditorTextColor,
  'editor-underline': EditorUnderline,
  'editor-unorderedlist': EditorUnorderedList,
  'form-check': FormCheck,
  'layout-grid': LayoutGrid,
  'layout-list': LayoutList,
  'layout-map': LayoutMap,
  'layout-table': LayoutTable,
  'logo-facebook': LogoFacebook,
  'logo-instagram': LogoInstagram,
  'logo-linkedin': LogoLinkedin,
  'logo-opengov': LogoOpengov,
  'logo-opengov-wand': LogoOpengovWand,
  'logo-twitter': LogoTwitter,
  'logo-youtube': LogoYoutube,
  'object-completeinspection': ObjectCompleteInspection,
  'object-document': ObjectDocument,
  'object-embed': ObjectEmbed,
  'object-employees': ObjectEmployees,
  'object-externallink': ObjectExternalLink,
  'object-folder': ObjectFolder,
  'object-group': ObjectGroup,
  'object-image': ObjectImage,
  'object-inspection': ObjectInspection,
  'object-map': ObjectMap,
  'object-notfound': ObjectNotFound,
  'object-payment': ObjectPayment,
  'object-tag': ObjectTag,
  'object-tags': ObjectTags,
  'object-user': ObjectUser,
  'object-video': ObjectVideo,
  'object-view': ObjectView,
  'object-world': ObjectWorld,
  'operator-add': OperatorAdd,
  'operator-contains': OperatorContains,
  'operator-divide': OperatorDivide,
  'opengov-logo': OpenGovLogo,
  'opengov-logo-wand': OpenGovLogoWand,
  'operator-doesnotcontain': OperatorDoesNotContain,
  'operator-equal': OperatorEqual,
  'operator-greaterthan': OperatorGreaterThan,
  'operator-greaterthanorequal': OperatorGreaterThanOrEqual,
  'operator-isfilled': OperatorIsFilled,
  'operator-isnotfilled': OperatorIsNotFilled,
  'operator-lessthan': OperatorLessThan,
  'operator-lessthanorequal': OperatorLessThanOrEqual,
  'operator-multiply': OperatorMultiply,
  'operator-notequal': OperatorNotEqual,
  'operator-subtract': OperatorSubtract,
  'product-b&p': ProductBnP,
  'product-eam': ProductEAM,
  'product-r&t': ProductRnT,
  'product-cit': ProductCIT,
  'product-od': ProductOD,
  'product-pro': ProductPro,
  'product-fin': ProductFin,
  'product-oth': ProductOTH,
  'status-blocked': StatusBlocked,
  'status-error': StatusError,
  'status-info': StatusInfo,
  'status-locked': StatusLocked,
  'status-shared': StatusShared,
  'status-success': StatusSuccess,
  'status-unlocked': StatusUnlocked,
  'status-warning': StatusWarning,
  'transaction-creditcard': TransactionCreditCard,
  'utility-admin': UtilityAdmin,
  'utility-batch': UtilityBatch,
  'utility-calculator': UtilityCalculator,
  'utility-comments': UtilityComments,
  'utility-directories': UtilityDirectories,
  'utility-documentation': UtilityDocumentation,
  'utility-excel': UtilityExcel,
  'utility-filter': UtilityFilter,
  'utility-help-outline': UtilityHelpOutline,
  'utility-help': UtilityHelp,
  'utility-info-outline': UtilityInfoOutline,
  'utility-info': UtilityInfo,
  'utility-menu': UtilityMenu,
  'utility-notes': UtilityNotes,
  'utility-notifications': UtilityNotifications,
  'utility-overflow': UtilityOverflow,
  'utility-overflow-horizontal': UtilityOverflowHorizontal,
  'utility-settings': UtilitySettings,
  'utility-spooler': UtilitySpooler
};
